import { Injectable } from "@angular/core";

@Injectable()
export class DateHelperService{
    constructor() {
    }
    getWeekEndDateByDate(date: Date): Date {
        let currentDay = date.getDay();
        return this.getPastOrFutureDate(date, (6 - currentDay));
    
      }
    
      getWeekStartDateByDate(date: Date): Date {
        let currentDay = date.getDay();
        return this.getPastOrFutureDate(date, -currentDay);
    
      }

      getPastOrFutureDate(date: Date, days: number): Date {
        let requiredDate = new Date(date);
        return new Date(requiredDate.setDate(requiredDate.getDate() + days));
      }

      getMonthByDate(date: Date): number {
        return date.getMonth()+1;
      }

      getPastOrFutureDateByMonths(date: Date, months: number): Date {
        let requiredDate = new Date(date);
        return new Date(requiredDate.setMonth(requiredDate.getMonth() + months));
  }

  Months = {'Jan': 1,'Feb': 2,'Mar': 3,'Apr': 4,'May': 5,'Jun': 6,'Jul': 7,'Aug': 8,'Sep': 9,'Oct': 10,'Nov': 11,'Dec': 12};
  getMonthNumber(month: string): number {
    return this.Months[month];
  }
}
